module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAUCAYAAABSx2cSAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEwAACxMBAJqcGAAAAU5JREFUOI3VkT9LQlEYh59zruKgaCAtIUTQFERLOAUGKvgF7hAi4aBES2NzH6GtppKirS+QOBhO/ZnaAmm5BqlQk1T33nNavKLXq0Ob73bOeZ+H33lfWOzSpml8ZA5j83r6hWJcg/DO0gM73WjNZtBo56qJINDKlpLfg9B9Z7d87gkkgNWNniBEESHSEfv3zi+wsqUktmwg5RZQsTLl4xFsuOIUeAFAiHTEseuewAcC6slBncFY/ved8rIK0QA2h1ePrnD3DFfcjoO2Jr/WrH1NwEEChXIkMhQETsEzEgSCoz//tybgqdgKd9i2HRbU3zL7S4GwH9SKZxl2NvC2ECCQs0ClfvKpxtWrdMjOEkgA19BHfnC1dfMJsNK66PkFIeQBDKetTdOwerFrgVoPmup4Oq31Q6p5WRGgR4/aNI1+oRifN912rprQAetdsPoD4eqmG1rsCvQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/wrong.png
// module id = 206
// module chunks = 0